import CrudSection from "./CrudSection";

const FIELDS = [
  { name: "title", label: "Title", type: "text", full: true },
  { name: "excerpt", label: "Excerpt", type: "textarea", full: true },
  { name: "category", label: "Category", type: "text", placeholder: "Speaking / Grammar …" },
  { name: "image", label: "Image URL", type: "text", full: true },
  { name: "date", label: "Date", type: "text", placeholder: "e.g. Jan 12, 2026" },
  { name: "read_time", label: "Read time", type: "text", placeholder: "e.g. 5 min read" },
  { name: "url", label: "Article URL", type: "text", full: true, placeholder: "https://…" },
  { name: "order", label: "Order", type: "number" },
  { name: "active", label: "Active", type: "checkbox", placeholder: "Show on website" },
];

export default function AdminBlogs() {
  return (
    <CrudSection
      title="Blogs"
      endpoint="blogs"
      testIdPrefix="blog"
      fields={FIELDS}
      defaultValues={{ active: true, order: 0 }}
      renderRow={(b) => (
        <div className="flex items-center gap-4">
          {b.image ? (
            <img src={b.image} alt="" className="w-14 h-14 rounded-xl object-cover border border-[#1F2547]/10" />
          ) : (
            <div className="w-14 h-14 rounded-xl bg-[#EFE9F7]" />
          )}
          <div className="min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <h3 className="font-display font-bold text-base text-[#1F2547] truncate">{b.title}</h3>
              {b.category && (
                <span className="text-[10px] font-bold uppercase tracking-[0.15em] px-2 py-0.5 rounded-full bg-[#C7DCF7] text-[#1F2547]">
                  {b.category}
                </span>
              )}
              {!b.active && (
                <span className="text-[10px] font-bold uppercase tracking-[0.15em] px-2 py-0.5 rounded-full bg-red-50 text-red-600">
                  Hidden
                </span>
              )}
            </div>
            <p className="text-sm text-[#5B6079] line-clamp-2">{b.excerpt}</p>
            <div className="text-xs text-[#5B6079] mt-1 font-medium">
              {b.date || "—"} · {b.read_time || "—"}
            </div>
          </div>
        </div>
      )}
    />
  );
}
